export default `
  :root {
      /* # Color Palette */
      --wuk-primary-color-pale: #fef7e6;
      --wuk-primary-color-light: #feefcc;
      --wuk-primary-color-normal: #fbd063;
      --wuk-primary-color-dark: #edb939;
      --wuk-primary-color: #fbd063;

      --wuk-secondary-color-pale: #fff1eb;
      --wuk-secondary-color-light: #ffdfc8;
      --wuk-secondary-color-normal: #ff8966;
      --wuk-secondary-color-dark: #fc6437;
      --wuk-secondary-color: var(--wuk-secondary-color-normal);
      --wuk-secondary-color-rgb: 255, 137, 102;

      --wuk-context-color-1: #1f222c;
      --wuk-context-color-1-rgb: 31, 34, 44;
      --wuk-context-color-2: #4c4e56;
      --wuk-context-color-3: #797a80;
      --wuk-context-color-4: #a5a7ab;
      --wuk-context-color-5: #bcbdc0;
      --wuk-context-color-6: #d2d3d5;
      --wuk-context-color-7: #e9e9ea;
      --wuk-context-color-8: #f4f4f4;

      /* # Buttons */
      /* ## Specific Color assigns for inputs */
      --wuk-button-theme-secondary-border: var(--wuk-primary-color);
      --wuk-button-theme-primary-background: var(--wuk-primary-color);
      --wuk-button-theme-primary-color: var(--wuk-context-color-1);
      --wuk-button-theme-primary-hover-background: var(--wuk-primary-color-dark);
      --wuk-button-theme-primary-hover-border: var(--wuk-primary-color-dark);
      --wuk-button-theme-primary-disabled-background: var(--wuk-primary-color-light);
      --wuk-button-theme-primary-disabled-color: var(--wuk-context-color-5);

      --wuk-button-theme-secondary-color: var(--wuk-context-color-2);
      --wuk-button-theme-secondary-border: transparent;
      --wuk-button-theme-secondary-background: var(--wuk-primary-color-light);
      --wuk-button-theme-secondary-hover-background: #EFEAE6;
      --wuk-button-theme-secondary-hover-color: var(--wuk-context-color-1);
      --wuk-button-theme-secondary-disabled-background: var(--wuk-primary-color-light);
      --wuk-button-theme-secondary-disabled-color: var(--wuk-context-color-5);
      --wuk-button-theme-secondary-disabled-border: var(--wuk-primary-color-light);

      --wuk-button-theme-tertiary-background: transparent;
      --wuk-button-theme-tertiary-color: var(--wuk-context-color-2);
      --wuk-button-theme-tertiary-border: transparent;
      --wuk-button-theme-tertiary-hover-background: transparent;
      --wuk-button-theme-tertiary-hover-color: var(--wuk-primary-color-dark);
      --wuk-button-theme-tertiary-disabled-background: transparent;
      --wuk-button-theme-tertiary-disabled-color: var(--wuk-context-color-5);

      --wuk-button-theme-text-color: var(--wuk-context-color-2);
      --wuk-button-theme-text-disabled-color: var(--wuk-context-color-5);
      --wuk-button-theme-text-hover-color: var(--wuk-primary-color-dark);

      /* # Notifications (Toasters) */
      --wuk-notification-info-background-color: #cAe2ea;

      /* # Font */
      --wuk-font-family: 'Montserrat';

      /* # Inputs */
      /* Sizing and Styling */
      --wuk-ruler-hover-background-color-wuk: var(--wuk-secondary-color-light);

      /* # Normal Checkbox */
      --wuk-toggle-input-icon-background-color: var(--wuk-primary-color-light);
      --wuk-toggle-input-hover-background-color: var(--wuk-primary-color-dark);
      --wuk-toggle-input-hover-text-color: var(--wuk-context-color-1);
      --wuk-toggle-input-checked-background-color: var(--wuk-primary-color);
      --wuk-toggle-input-checked-background-color-wuk: var(--wuk-primary-color);

      /* #Input range */
      --wuk-range-thumb-border-color-wuk: var(--wuk-primary-color);
    }
`;
